import config from "@@/config";

export default () => {
	return config;
};
